import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import HomeContentSection from '../../Home/HomeContentSection';
import {colors} from '../../../style/constants';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import Latests from './Latests';

const useStyles = makeStyles((theme) => ({
  post: {
    position: 'relative',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1,
      height: 120,
      background: colors.DARK_GREY,
      position: 'absolute',
      left: 'calc(50vw - 0.5px)',
      top: -30,
      [theme.breakpoints.down('xs')]: {
        height: 75,
        top: -15,
      },
      '& > span': {
        display: 'block',
        position: 'absolute',
        width: 9,
        height: 9,
        border: colors.DARK_GREY + ' 1px solid',
        borderRadius: '50%',
      }
    }
  },
  tv: {
    border: '10px black solid',
    borderRadius: 10,
    boxSizing: 'border-box',
    boxShadow: '-20px 20px 20px 0px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('xs')]: {
      border: '5px black solid',
      borderRadius: 5,
      boxShadow: '-10px 10px 10px 0px rgba(0,0,0,0.5)',
    },
  },
  content: {
    borderTop: colors.DARK_GREY + ' 1px solid',
    marginTop: 75,
    '& > :first-child > h5': {
      marginTop: 'calc(-1.25em - 5px)'
    },
    '& p, .gatsby-image-wrapper': {
      marginTop: 15,
    },
    '& h2, h3, h4, h5, h6': {
      marginTop: 30,
    },
    '& > ul': {
      marginTop: 15,
      '& > li': {
        paddingLeft: 15,
        position: 'relative',
        marginTop: 5,
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 'calc(1.5625em/2)',
          width: 7.5,
          height: 7.5,
          borderRadius: '50%',
          background: colors.ATT_BLUE
        },
        '& p': {
          marginTop: 0
        }
      }
    }
  }
}));

const PostContent = (props) => {
  
  const Bold = ({ children }) => <strong>{children}</strong>
  const Text = ({ children }) => <p>{children}</p>

  const options = {
    renderMark: {
      [MARKS.BOLD]: text => <Bold>{text}</Bold>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => children.length === 0 ? '' : <Text>{children}</Text>,
      [BLOCKS.EMBEDDED_ASSET]: node => {
        return (
          <Grid item xs={8}>
            <GatsbyImage image={node.data.target.gatsbyImageData} alt=""/>
          </Grid>
        )
      },
    },
  }

  const classes = useStyles();
  return (
    <>
    <article className={classes.post}>
      <span><span/></span>
      <Container>
        <Grid container justifyContent='center'>
          <Grid className={classes.tv} item xs={12} sm={10} md={8}>
            <GatsbyImage image={props.data.headerImg.gatsbyImageData} alt=""/>
          </Grid>
        </Grid>
        <Grid container justifyContent='center'>
          <Grid className={classes.content} item xs={12} sm={10} md={8}>
            <Grid container justifyContent='flex-end'>
              <h5>{props.data.createdAt}</h5>
            </Grid>
            {renderRichText(props.data.content, options)}
          </Grid>
        </Grid>
      </Container>
    </article>
    <Latests lang={props.lang} posts={props.latests} />
    <HomeContentSection/>
    </>
  )
}

export default PostContent
